import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

export interface AnalyticsChartSeries {
  key: string
  label: string
  color: string
}

export const AnalyticsActivityChart = ({
  data,
  series,
  locale = 'en',
  stacked = true,
}: {
  data: Array<Record<string, string | number>>
  series: AnalyticsChartSeries[]
  locale?: string
  stacked?: boolean
}) => {
  const formatDay = (value: string) => {
    const raw = String(value).slice(0, 10)
    const [year, month, day] = raw.split('-').map(Number)
    if (!year || !month || !day) return raw
    return new Date(year, month - 1, day).toLocaleDateString(
      locale.startsWith('sv') ? 'sv-SE' : 'en-GB',
      { month: 'short', day: 'numeric' }
    )
  }

  return (
    <div className="h-56 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} barGap={2}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" />
          <XAxis
            dataKey="day"
            tickFormatter={formatDay}
            tick={{ fontSize: 11, fill: '#6b7280' }}
            axisLine={false}
            tickLine={false}
            minTickGap={24}
          />
          <YAxis
            allowDecimals={false}
            tick={{ fontSize: 11, fill: '#6b7280' }}
            axisLine={false}
            tickLine={false}
            width={28}
          />
          <Tooltip
            labelFormatter={(label) => formatDay(String(label))}
            contentStyle={{
              borderRadius: 12,
              border: '1px solid #e5e7eb',
              fontSize: 12,
            }}
          />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          {series.map((item) => (
            <Bar
              key={item.key}
              dataKey={item.key}
              name={item.label}
              fill={item.color}
              radius={[4, 4, 0, 0]}
              maxBarSize={28}
              stackId={stacked ? 'activity' : undefined}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
